<div class="ngx-pagination-wrapper"
     *ngIf="pagination && pagination.count > pagination.limit"
     [style.display]="config.paginationEnabled ? '' : 'none'">

    <div class="ngx-pagination-steps"
         *ngIf="pagination.offset > 0 || pagination.count >= pagination.limit">

        <pagination-template
          #paginationDirective="paginationApi"
          [id]="id"
          [maxSize]="maxSize"
          (pageChange)="onPageChange($event)">

            <ul class="ngx-pagination"
                role="navigation"
                [attr.aria-label]="screenReaderPaginationLabel">

                <!-- Previous Button -->
                <li class="pagination-previous"
                    [class.disabled]="paginationDirective.isFirstPage()"
                    *ngIf="directionLinks">
                    <a tabindex="0"
                       *ngIf="!paginationDirective.isFirstPage() && !linkPages"
                       (keyup.enter)="paginationDirective.previous()"
                       (click)="paginationDirective.previous()"
                       [attr.aria-label]="'Previous ' + screenReaderPageLabel">
                        <span class="pagination-arrow">‹</span>
                    </a>
                    <a *ngIf="!paginationDirective.isFirstPage() && linkPages"
                       [routerLink]="[]"
                       [queryParams]="pageQuery(paginationDirective.getCurrent() - 1)"
                       queryParamsHandling="merge"
                       rel="prev"
                       [attr.aria-label]="'Previous ' + screenReaderPageLabel">
                        <span class="pagination-arrow">‹</span>
                    </a>
                    <span *ngIf="paginationDirective.isFirstPage()" class="pagination-arrow disabled">
          </span>
                </li>

                <!-- Page Numbers -->
                <li *ngFor="let page of paginationDirective.pages"
                    [class.current]="paginationDirective.getCurrent() === page.value"
                    [class.ellipsis]="page.label === '...'">

                    <a tabindex="0"
                       (keyup.enter)="paginationDirective.setCurrent(page.value)"
                       (click)="paginationDirective.setCurrent(page.value)"
                       *ngIf="paginationDirective.getCurrent() !== page.value && page.label !== '...' && !linkPages">
                        <span class="show-for-sr">{{ screenReaderPageLabel }} </span>
                        <span>{{ page.label }}</span>
                    </a>
                    <a [routerLink]="[]"
                       [queryParams]="pageQuery(page.value)"
                       queryParamsHandling="merge"
                       *ngIf="paginationDirective.getCurrent() !== page.value && page.label !== '...' && linkPages">
                        <span class="show-for-sr">{{ screenReaderPageLabel }} </span>
                        <span>{{ page.label }}</span>
                    </a>

                    <span *ngIf="page.label === '...'" class="ellipsis-dots">
            {{ page.label }}
          </span>

                    <ng-container *ngIf="paginationDirective.getCurrent() === page.value">
                        <span class="show-for-sr">{{ screenReaderCurrentLabel }} </span>
                        <span>{{ page.label }}</span>
                    </ng-container>
                </li>

                <!-- Next Button -->
                <li class="pagination-next"
                    [class.disabled]="paginationDirective.isLastPage()"
                    *ngIf="directionLinks">
                    <a tabindex="0"
                       *ngIf="!paginationDirective.isLastPage() && !linkPages"
                       (keyup.enter)="paginationDirective.next()"
                       (click)="paginationDirective.next()"
                       [attr.aria-label]="'Next ' + screenReaderPageLabel">
                        <span class="pagination-arrow">›</span>
                    </a>
                    <a *ngIf="!paginationDirective.isLastPage() && linkPages"
                       [routerLink]="[]"
                       [queryParams]="pageQuery(paginationDirective.getCurrent() + 1)"
                       queryParamsHandling="merge"
                       rel="next"
                       [attr.aria-label]="'Next ' + screenReaderPageLabel">
                        <span class="pagination-arrow">›</span>
                    </a>
                    <span *ngIf="paginationDirective.isLastPage()" class="pagination-arrow disabled">
            ›
          </span>
                </li>
            </ul>
        </pagination-template>
    </div>

    <!-- Pagination Range Dropdown -->
    <div class="ngx-pagination-range"
         #paginationRange
         *ngIf="config.paginationRangeEnabled">
        <div class="ngx-dropdown ngx-pagination-range-dropdown" id="rowAmount">
            <div class="ngx-btn-group">
                <div class="ngx-pagination-range-dropdown-button"
                     (click)="showRange = !showRange">
                    {{ pagination.limit }}
                    <nb-icon icon="chevron-down-outline"
                             [class.rotated]="showRange">
                    </nb-icon>
                </div>
                <ul class="ngx-menu" *ngIf="showRange">
                    <li class="ngx-pagination-range-dropdown-button-item"
                        [class.ngx-pagination-range--selected]="limit === pagination.limit"
                        (click)="changeLimit(limit, false)"
                        *ngFor="let limit of ranges">
                        <span>{{ limit }}</span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>
